module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, _vm._l((_vm.columnsTemplate), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "control"
    }, [_c('b-checkbox', {
      model: {
        value: (column.visible),
        callback: function($$v) {
          _vm.$set(column, "visible", $$v)
        },
        expression: "column.visible"
      }
    }, [_vm._v("\n                    " + _vm._s(column.title) + "\n                ")])], 1)
  })), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((_vm.columnsTemplate), function(column, index) {
          return _c('b-table-column', {
            key: index,
            attrs: {
              "label": column.title,
              "visible": column.visible
            }
          }, [_vm._v("\n                    " + _vm._s(props.row[column.field]) + "\n                ")])
        })
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4becfa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExToggleColumns.vue
// module id = 1223
// module chunks = 1 81